import { combineReducers } from "@reduxjs/toolkit";

import Modals from "./ModalsSlice";
export { Modals };

import Notifications from "./NotificationsSlice";
export { Notifications };

export default combineReducers({ Modals, Notifications });
